import React from "react"
import "./Home.scss"

const Home = () => {
  return (
    <div className="home-page">
        Homes
    </div>
  )
}

export default Home